import { useId, type ReactNode } from 'react'
import clsx from 'clsx'
import styled from 'styled-components'
import Clickable from 'components/Common/Clickable'
import Expander from 'components/utils/Expander'
import Group from 'components/utils/Group'
import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'
import Heading from 'LuxKit/Typography/Heading'

const Chevron = styled.div`
  display: inline-flex;
  transform: rotate(-90deg);

  &.expanded {
    transform: rotate(0deg);
  }
  transition: transform 200ms ease;

  /* Collapsed, the chevron points towards inline-end */
  [dir="rtl"] &:not(.expanded) {
    transform: rotate(90deg);
  }
`

interface Props {
  title: string
  expanded: boolean
  onToggle: () => void
  action?: ReactNode
  children: ReactNode
}

function CollapsibleItinerarySection({ title, expanded, onToggle, action, children }: Props) {
  const panelId = useId()

  return (
    <Group direction="vertical" gap={12} fullWidth>
      <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center" gap={8} fullWidth>
        <Clickable onClick={onToggle} aria-expanded={expanded} aria-controls={panelId}>
          <Group direction="horizontal" gap={8} verticalAlign="center">
            <Chevron className={clsx({ expanded })}><LineAngleDownIcon size="S" /></Chevron>
            <Heading variant="heading6">{title}</Heading>
          </Group>
        </Clickable>
        {action}
      </Group>
      <Expander expanded={expanded}>
        <div id={panelId} inert={!expanded} aria-hidden={!expanded}>
          <Group direction="vertical" gap={12} fullWidth>
            {children}
          </Group>
        </div>
      </Expander>
    </Group>
  )
}

export default CollapsibleItinerarySection
